import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import {  Typography } from "@mui/material";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { Actions } from "../../components/actionsMenu/ActionsMenu";
import { Progress } from "../../components/progress/Progress";
import { CallButton } from "../../components/phoneLetsCall/CallButton";

type LeadsHeaderProps = {
    actions?: Actions;
};

export const LeadDetailHeader = ({ actions }: LeadsHeaderProps) => {
    const record = useContext(RecordContext);

    if (!record) return null;
    const { first_name, last_name } = record.item;

    return (
        <>
            <DetailHeader actions={actions} collection={record.collection}>
                <Typography variant="h6" color="secondary">
                    Lead
                </Typography>
                <Typography variant="h5">
                    {first_name} {last_name}
                </Typography>
                <CallButton phone={record.item.phone} chipPlacement="below" />
            </DetailHeader>
            {record.type === "detail" ? <Progress context={record} /> : null}
        </>
    );
};
